import React from 'react'
import PropTypes from 'prop-types'

import MetaDataHelmet from '../../Shared/MetaDataHelmet'
import LandingPageRules from './Rules/LandingPageRules'
import LandingPageCategories from './Categories/LandingPageCategories'
import LandingPagePartnersSection from './Partners/LandingPagePartnersSection'
import LandingPageGallery from './Gallery/LandingPageGallery'

function LandingPage({ competitionSlug, openEmptyModal }) {
  const metaTitle = I18n.t(`competition.${competitionSlug}.meta.title.main_page`)
  const metaDescription = I18n.t(`competition.${competitionSlug}.meta.description.main_page`)
  const competitionTitle = I18n.t(`competition.${competitionSlug}.title`)
  const competitionDescription = I18n.t(`competition.${competitionSlug}.description_html`)

  return (
    <div className="competition-landing-page">
      <MetaDataHelmet title={metaTitle} description={metaDescription} />

      <section className="content-section content-section--light section--description-and-rules">
        <div className="container-fixed">
          <h2 className="content-section__title">What is the CGTrader {competitionTitle}?</h2>
          <p className="content-section__subtitle">
            <span dangerouslySetInnerHTML={{ __html: competitionDescription }} />
          </p>
          <LandingPageRules competitionTitle={competitionTitle} />
        </div>
      </section>

      <LandingPageCategories competitionSlug={competitionSlug} />

      <LandingPagePartnersSection competitionSlug={competitionSlug} />

      <section className="content-section content-section--dark section--about-us">
        <div className="container-fixed">
          <h2 className="content-section__title">About CGTrader</h2>
          <p className="content-section__subtitle">
            <a className="link--primary-dark" href="https://www.cgtrader.com" target="_blank" rel="noreferrer">CGTrader</a> is the
            largest 3D model marketplace for computer graphics, virtual and augmented reality, game creation assets,
            backed by a strong professional designer community. Customers can choose from 610 000
            high-quality <a className="link--primary-dark" href="https://www.cgtrader.com/3d-models" target="_blank" rel="noreferrer">3D models</a> that
            can be used in their projects, shortening project development time and saving resources. Designers can also
            sell <a className="link--primary-dark" href="https://www.cgtrader.com/pages/sell-3d-models" target="_blank" rel="noreferrer">3D models</a> and
            earn up to 80% of earnings.
          </p>
        </div>
      </section>

      <LandingPageGallery competitionSlug={competitionSlug} />
    </div>
  )
}

LandingPage.propTypes = {
  competitionSlug: PropTypes.string.isRequired,
  openEmptyModal: PropTypes.func.isRequired,
}

export default LandingPage
